import * as React from "react";
import { useEventListener } from "usehooks-ts";
export const IframeContext = React.createContext<boolean | null>(null);

export function IframeProvider(props: { iframe: boolean; children: React.ReactNode }) {
  useExternalLinks(props.iframe);
  return <IframeContext.Provider value={props.iframe}>{props.children}</IframeContext.Provider>;
}
export function useIframe() {
  return React.useContext(IframeContext);
}

/**
 * Catch all anchor clicks and instead of navigating them on the router, open them in a
 * new tab, when we're in an iframe.
 */
export const useExternalLinks = (enabled: boolean) => {
  const handler = React.useCallback(
    function (event: MouseEvent) {
      if (!enabled) {
        return;
      }
      const target = event.target as HTMLElement;
      const link = target.closest("a");
      if (link && link.href) {
        event.preventDefault();
        event.stopPropagation();
        window.open(link.href, "_blank");
      }
    },
    [enabled],
  );
  useEventListener("click", handler, undefined, { capture: true });
};
